import { useProject as useProjectQuery } from "../../../../hooks/query";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Box, Divider } from "@mui/joy";
import { BriefcaseBusiness, CalendarDays, FileStack, Settings, SquareLibrary } from "lucide-react";

import { useProject } from "../../../../hooks";
import { SummaryCard } from "./SummaryCard";
import { ListTask } from "../../../Tasks";
import { Overview, Settings as SettingsCmt } from "./components";
import { Documentation } from "./Documentation";
import { NavigationTabs } from "./NavigationTabs";
import { Timeline } from "./Timeline";
import { Notes } from "./Notes";

const tabList = [
    {
        name: "Tasks",
        icon: <BriefcaseBusiness size={18} />,
        component: <ListTask />,
    },
    {
        name: "Overview",
        icon: <SquareLibrary size={18} />,
        component: <Overview />,
    },

    {
        name: "Documents",
        icon: <FileStack size={18} />,
        component: <Documentation />,
    },
    {
        name: "Manage",
        icon: <Settings size={18} />,
        component: <SettingsCmt />,
    },
    {
        name: "Timeline",
        icon: <CalendarDays size={18} />,
        component: <Timeline />,
    },
];

export default function ProjectDetails() {
    const { setProject } = useProject();
    const params = useParams();
    const id = params.id as string;

    const { useListById } = useProjectQuery();
    const listProjectByIdSvc = useListById();

    useEffect(() => {
        if (id) {
            setProject({ id });
        }
    }, [id]);

    return (
        <Box flex={1} display={"flex"} overflow={"auto"}>
            <Box flex={1} display={"flex"} flexDirection={"column"} position={"inherit"} id={"project-details-parent"}>
                <Box my={2} mx={2}>
                    <SummaryCard />
                </Box>
                <Divider />
                <Box mt={2} ml={0} display={"flex"} gap={2}>
                    <NavigationTabs tabList={tabList} loading={listProjectByIdSvc.isPending} />
                </Box>
                <Divider />
            </Box>
            <Divider orientation="vertical" sx={{ position: "sticky", top: 0 }} />
            <Notes />
        </Box>
    );
}
